import * as React from "react"

import { cn } from "@/lib/utils"

interface TextareaProps extends React.ComponentProps<"textarea"> {
  error?: boolean
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, ...props }, ref) => {
    const isError = error || props.style?.borderColor === 'var(--error)' || props.style?.borderColor === 'var(--destructive)'
    
    return (
      <textarea
        className={cn(
          'flex min-h-[80px] w-full rounded-md text-base font-[var(--font-body)] bg-[var(--card-bg)] text-[var(--text-primary)] placeholder:text-[var(--text-secondary)] outline-none transition-[border-color] duration-[var(--duration-normal)] ease-[var(--ease-smooth)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          isError ? 'border border-[var(--error)]' : 'border border-[var(--border)]',
          className
        )}
        onFocus={(e) => {
          if (!e.currentTarget.disabled) {
            const borderColor = isError ? 'var(--error)' : 'var(--primary)'
            const boxShadow = isError 
              ? '0 0 0 3px var(--focus-ring-error)'
              : '0 0 0 3px var(--focus-ring-primary)'
            e.currentTarget.style.borderColor = borderColor
            e.currentTarget.style.boxShadow = boxShadow
          }
          props.onFocus?.(e)
        }}
        onBlur={(e) => {
          const borderColor = isError ? 'var(--error)' : 'var(--border)'
          e.currentTarget.style.borderColor = borderColor
          e.currentTarget.style.boxShadow = ''
          props.onBlur?.(e)
        }}
        ref={ref}
        {...props}
      />
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
